//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";
// component
import MyPageProduct from "../../component/content/MyPageProduct";
import MypageBtn from "../../component/button/MypageBtn";

// img
import product from "../../assets/img/picture/product_01.jpg";
import more from "../../assets/img/icon/icon_more2.svg";

// responsive
import { M, T } from "../../utils/MT";

export default function ProductInfo(props) {
    return (
        <Wrap>
            {/* 타이틀 */}
            <MyPageTitleBox>
                <MyPageTitle>주문상품정보</MyPageTitle>
            </MyPageTitleBox>
            <OrderTableWrap>
                {/* 테이블 제목 */}
                <PC>
                    <TabelTitle>
                        <TableList>상품정보</TableList>
                        <TableList>배송비</TableList>
                        <TableList>진행상태</TableList>
                    </TabelTitle>
                </PC>

                {/* 테이블 리스트 */}
                {props.orderlistData.map((item, index) => {
                    return (
                        <OrderListBox key={item.id}>
                            <MyPageProduct
                                id={item.id}
                                productImg={item.productImg}
                                itemName={item.itemName}
                                price={item.price}
                                num={item.num}
                                option={item.option}
                                i={item.id}
                            />
                            {item.delivery ? <DelText>{item.delivery} 원</DelText> : <DelText>무료배송</DelText>}
                            {/* 버튼리스트 컴포넌트 */}
                            <MypageBtn state={item.state} />
                        </OrderListBox>
                    );
                })}
            </OrderTableWrap>
        </Wrap>
    );
}
const Wrap = styled.article`
    position: relative;
    width: 100%;
`;
const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
const OrderTableWrap = styled.div`
    margin-top: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
    }
`;
const TabelTitle = styled.ul`
    display: flex;
    align-items: center;

    padding: calc(100vw * (20 / 1920)) 0;

    border-top: 1px solid #000;
    border-bottom: 1px solid #dddddd;

    & > li {
        flex-shrink: 0;
    }

    & > li:nth-child(1) {
        width: calc(100vw * (430 / 1920));
    }
    & > li:nth-child(2) {
        display: flex;
        justify-content: center;
        align-items: center;

        width: calc(100vw * (185 / 1920));
    }
    & > li:nth-child(3) {
        width: calc(100vw * (225 / 1920));
    }

    @media screen and (max-width: 1300px) {
        & > li:nth-child(1) {
            width: calc(100vw * (430 / 1300));
        }
        & > li:nth-child(2) {
            width: calc(100vw * (185 / 1300));
        }
        & > li:nth-child(3) {
            width: calc(100vw * (225 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        & > li:nth-child(1) {
            width: 100%;
        }
        & > li:nth-child(2) {
            width: 100%;
            justify-content: left;

            padding-left: ${M(98)};
        }
        & > li:nth-child(3) {
            width: auto;
            margin-left: auto;
        }
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)} 0;
    }
`;
const TableList = styled.li`
    font: calc(100vw * (15 / 1920)) "Noto-M";
    text-align: center;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
    }
`;

const OrderListBox = styled(TabelTitle)`
    border-bottom: 1px solid #dddddd;
    border-top: none;

    padding: calc(100vw * (20 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;

        /* & > li:nth-child(1) {
            width: calc(100vw * (430 / 1300));
        }
        & > li:nth-child(2) {
            width: calc(100vw * (185 / 1300));
        }
        & > li:nth-child(3) {
            width: calc(100vw * (225 / 1300));
        } */

        /* & > li:nth-child(1) {
            width: calc(100vw * (385 / 1300));
        }
        & li:nth-child(2) {
            width: calc(100vw * (135 / 1300));
        }
        & li:nth-child(3) {
            width: calc(100vw * (185 / 1300));
        }
        & li:nth-child(4) {
            width: calc(100vw * (165 / 1300));
        } */
    }

    @media screen and (max-width: 900px) {
        flex-wrap: wrap;

        padding: ${M(20)} 0;

        &:first-child {
            border-top: 1px solid #000000;
        }

        /* & > li:nth-child(1) {
            width: 100%;
        }
        & li:nth-child(2) {
            width: ${M(250)};
        }
        & li:nth-child(3) {
            width: 100%;

            & div {
                margin-left: auto;
            }
        }
        & li:nth-child(4) {
            width: auto;
        } */
    }
`;
const DelText = styled.li`
    font-size: calc(100vw * (14 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-top: ${M(10)};
    }
`;
